import React, { FC } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

interface ILoader {
    isLoading: boolean
}


/**
 * Loader component for showing progress
 *
 * @param {{ isLoading: any; }} {
    isLoading
}
 * @returns {*}
 */
const Loader: FC<ILoader> = ({
    isLoading
}) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}

export default Loader